import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Appointment } from '../types/entities';

interface AppointmentDeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  appointment: Appointment | null;
}

const AppointmentDeleteConfirmationDialog: React.FC<AppointmentDeleteConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  appointment,
}) => {
  const { t } = useTranslation();
  if (!appointment) return null;

  const formatDate = (date: Date): string => {
    return new Date(date).toLocaleDateString('pl-PL', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{t('dialogs.confirmDeleteAppointment')}</Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          {t('dialogs.deleteAppointmentConfirmation', { date: formatDate(appointment.date) })}
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>{t('common.client')}:</strong> {appointment.client?.name || t('calendar.unknownClient')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>{t('common.hairdresser')}:</strong> {appointment.hairdresser?.name || t('calendar.unknownHairdresser')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>{t('common.services')}:</strong> {appointment.services?.length || 0}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {t('dialogs.deleteAppointmentWarning')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} color="error" variant="contained">
          {t('common.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppointmentDeleteConfirmationDialog;
